module.exports = __webpack_public_path__ + "img/insead.96338fc0.png";